export default __webpack_public_path__ + "static/media/cert-ngo-consumer.0a13b323.jpg";